import Layout from '@/components/feature/Layout';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import MachinesSection from './components/MachinesSection';
import ApplicationsSection from './components/ApplicationsSection';
import WhySection from './components/WhySection';
import TechTableSection from './components/TechTableSection';
import PortfolioSection from './components/PortfolioSection';
import GuidesSection from './components/GuidesSection';
import FAQSection from './components/FAQSection';
import CompanySection from './components/CompanySection';
import FinalCTASection from './components/FinalCTASection';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'SoldaGeo Importações',
      url: 'https://maquinadesoldageomembrana.com.br',
      logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop,q=95/A0xVvobDbRIBrVE7/rapidgeo__2_-removebg-preview-reducido-d95gQJQOpJIwwOxp.png',
      telephone: '+554891802091',
      email: 'contato@soldageo.com.br',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Rua Hipólito Gregório Pereira 127, Canasvieiras',
        addressLocality: 'Florianópolis',
        addressRegion: 'SC',
        addressCountry: 'BR',
      },
      sameAs: [
        'https://www.facebook.com/share/17JUHvyQmW/',
        'https://www.instagram.com/soldageobrasil/',
      ],
    },
    {
      '@type': 'WebSite',
      name: 'Máquina de Solda Geomembrana',
      url: 'https://maquinadesoldageomembrana.com.br',
    },
    {
      '@type': 'WebPage',
      '@id': 'https://maquinadesoldageomembrana.com.br/',
      url: 'https://maquinadesoldageomembrana.com.br/',
      name: 'Máquina de Solda Geomembrana | Equipamentos Profissionais',
      description: 'Máquinas de solda geomembrana profissionais. Cunha quente, extrusoras e acessórios para impermeabilização.',
      inLanguage: 'pt-BR',
    },
  ],
};

export default function Home() {
  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <HeroSection />
      <StatsBar />
      <MachinesSection />
      <ApplicationsSection />
      <WhySection />
      <TechTableSection />
      <PortfolioSection />
      <GuidesSection />
      <FAQSection />
      <CompanySection />
      <FinalCTASection />
    </Layout>
  );
}